import React from "react";
import styles from "./Numpad.module.css";
import Delete from "../static/images/component_svg/delnum.svg";
import Reset from "../static/images/component_svg/resetnum.svg";

const Numpad = ({ onDigitClick, onResetClick, onDeleteClick }) => {
  return (
    <div className={styles.numpad}>
      <div className={styles.number}>
        {[...Array(9)].map((_, index) => (
          <button
            key={index + 1}
            className={styles.button}
            onClick={() => onDigitClick(index + 1)}
          >
            {index + 1}
          </button>
        ))}
      </div>
      <div className={styles.row}>
        <button className={styles.button} onClick={onResetClick}>
          <img src={Reset} className={styles.icon} alt="Resetnumber" />
        </button>
        <button className={styles.button} onClick={() => onDigitClick(0)}>
          0
        </button>
        <button className={styles.button} onClick={onDeleteClick}>
          <img src={Delete} className={styles.icon} alt="Delnumber" />
        </button>
      </div>
    </div>
  );
};

export default Numpad;
